import * as Collapsible from "@radix-ui/react-collapsible";
import { ChevronDown } from "lucide-react";
import styled, { CSSProperties, css, keyframes } from "styled-components";
import { colorMixin, spacingMixin, typographyMixin } from "../../helpers";

export const Chevron = styled(ChevronDown)`
    transition: transform 150ms;
`;

export const Header = styled.div<{ $collapsible: boolean; $wrap: NonNullable<CSSProperties["flexWrap"]> }>`
    display: flex;
    flex-wrap: ${({ $wrap }) => $wrap};
    justify-content: space-between;
    align-items: center;

    row-gap: ${spacingMixin(1.5)};
    column-gap: ${spacingMixin(2)};

    ${({ $collapsible }) =>
        $collapsible &&
        css`
            user-select: none;
            cursor: pointer;

            &[data-state="open"] ${Chevron} {
                transform: rotate3d(1, 0, 0, 180deg);
            }
        `};
`;

export const HeaderContent = styled.div`
    ${typographyMixin("label-regular-semibold")};
    color: ${colorMixin("text-primary-1200")};
`;

export const BlockContent = styled.div`
    &&&[data-state="closed"] {
        display: none;
    }
`;

export const Block = styled.div<{ $withoutContainerStyles: boolean }>`
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    ${typographyMixin("paragraph-regular-regular")};
    color: ${colorMixin("text-primary-900")};
    background: ${colorMixin("background-primary-base")};
    overflow: hidden;

    ${({ $withoutContainerStyles }) => {
        if ($withoutContainerStyles) {
            return "";
        }

        return css`
            border-radius: 4px;
            border: 1px solid ${colorMixin("border-primary-100")};
            padding: 24px;
        `;
    }}

    width: 100%;
    gap: 16px;

    & &[data-nesting="built-in"] {
        border-radius: 0;
        border: none;
        margin-left: -24px;
        width: calc(100% + 48px);
        padding: 0;

        ${BlockContent} {
            border-top: 1px solid ${colorMixin("border-primary-100")};
            border-bottom: 1px solid ${colorMixin("border-primary-100")};
        }
    }
`;

const slideDown = keyframes`
    from {
        height: 0;
    }

    to {
        height: var(--radix-collapsible-content-height);
    }
`;

const slideUp = keyframes`
    from {
        height: var(--radix-collapsible-content-height);
    }

    to {
        height: 0;
    }
`;

export const AnimatedContent = styled(Collapsible.Content)`
    overflow: hidden;

    &[data-state="open"] {
        animation: ${slideDown} 200ms ease-out;
    }

    &[data-state="closed"] {
        animation: ${slideUp} 200ms ease-out;
    }
`;
